var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiMoneyDollarCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10620_25811)",
    transform: "translate(7, 7) scale(0.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C9.8494 44 0 34.1506 0 22C0 9.8494 9.8494 0 22 0C34.1506 0 44 9.8494 44 22C44 34.1506 34.1506 44 22 44ZM14.3 26.4V30.8H19.8V35.2H24.2V30.8H26.4C27.8587 30.8 29.2576 30.2205 30.2891 29.1891C31.3205 28.1576 31.9 26.7587 31.9 25.3C31.9 23.8413 31.3205 22.4424 30.2891 21.4109C29.2576 20.3795 27.8587 19.8 26.4 19.8H17.6C17.3083 19.8 17.0285 19.6841 16.8222 19.4778C16.6159 19.2715 16.5 18.9917 16.5 18.7C16.5 18.4083 16.6159 18.1285 16.8222 17.9222C17.0285 17.7159 17.3083 17.6 17.6 17.6H29.7V13.2H24.2V8.8H19.8V13.2H17.6C16.1413 13.2 14.7424 13.7795 13.7109 14.8109C12.6795 15.8424 12.1 17.2413 12.1 18.7C12.1 20.1587 12.6795 21.5576 13.7109 22.5891C14.7424 23.6205 16.1413 24.2 17.6 24.2H26.4C26.6917 24.2 26.9715 24.3159 27.1778 24.5222C27.3841 24.7285 27.5 25.0083 27.5 25.3C27.5 25.5917 27.3841 25.8715 27.1778 26.0778C26.9715 26.2841 26.6917 26.4 26.4 26.4H14.3Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10620_25811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiMoneyDollarCircleFill);
export default __webpack_public_path__ + "static/media/ri_money-dollar-circle-fill.8fe661bf6d44c95919240e7e395b63f6.svg";
export { ForwardRef as ReactComponent };